module.exports = __webpack_public_path__ + "static/media/09n.4e35cc56.png";